import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { PUTSystemCatalogItem } from '../queries'

// Assuming these are the types from your POSTSystemCatalogCategory function
// Adjust these types according to your actual implementation
type CategoryData = unknown // The return type of your mutation
type CategoryError = unknown // The error type
type CategoryVariables = unknown // The variables type

function usePutSystemCatalogItem(
  options?: Omit<
    UseMutationOptions<CategoryData, CategoryError, CategoryVariables>,
    'mutationFn'
  >
) {
  return useMutation({
    mutationFn: PUTSystemCatalogItem,
    ...options,
  })
}

export default usePutSystemCatalogItem
